module.exports = __webpack_public_path__ + "files/c79eb2814abd13567272a806c4a29fa7.png";